import { createFileRoute } from '@tanstack/react-router'
import { CategoriesPageLayout } from '~/components/routes/categories/categories-page-layout'
import { InternalCategoriesPanel } from '~/components/routes/categories/InternalCategoriesPanel'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/categories/internal/')({
  staticData: {
    permission: ['read', 'categories'],
  },
  component: InternalCategoriesTabPage,
})
withRoutePermissions(Route)

function InternalCategoriesTabPage() {
  return (
    <CategoriesPageLayout activeTab="internal">
      <InternalCategoriesPanel />
    </CategoriesPageLayout>
  )
}
